
// 选择面板控制
function indexxuanze() {
  $(".more21").click(function () {
    $(".index-select").fadeOut()
  })

  $(".less21").click(function () {
    $(".index-select .box1").fadeOut()
    $(".index-select .box2").fadeIn()
  })

  $(".return21").click(function () {
    $(".index-select .box1").fadeIn()
    $(".index-select .box2").fadeOut()
  })
}
indexxuanze()

// cookies2 - 控制 .index-select 首次显示
function setCookie2(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}

function getCookie2(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
  }
  return "";
}

$(document).ready(function() {
  var tyys2 = getCookie2("tyys2");
  
  if (tyys2 != "2") {
    $(".index-select").css("display", "block");
    
    $(".more21").off('click').on('click', function () {
      $(".index-select").css("display", "none");
      setCookie2("tyys2", 2, 7); // 设置7天有效期
    });
  } else {
    $(".index-select").css("display", "none");
  }
});
